import { render, staticRenderFns } from "./SiloEventDisplay.vue?vue&type=template&id=52d75d08"
import script from "./SiloEventDisplay.vue?vue&type=script&lang=js"
export * from "./SiloEventDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports